<template>
    <div>
        <b-loading :is-full-page="true" :active="isLoading"></b-loading>
        <div>
            <div class="level is-vcentered">
                <div class="level-left">
                    <h1 class="title is-size-4">
                        View Project
                        <span class="tag" :class="projectServiceHelper.getStateStyle(project.state)">{{ project.state }}</span>
                    </h1>
                </div>
                <div class="level-right">
                    <div class="field is-grouped is-grouped-right">
                        <p class="control">
                            <button class="button is-outlined" @click.prevent="handleBack('/')">Back</button>
                        </p>
                    </div>
                </div>
            </div>
            <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
            </b-notification>
            <section class="section project-details">
                <h2 class="title is-size-4">Project Details</h2>
                    <b-field label="Project Name" horizontal>
                        <span class="control">{{project.name}}</span>
                    </b-field>
                    <b-field label="Conversation Topic" horizontal class="is-baseline-aligned">
                        <div class="modal-button-control">
                            <span class="control" :class="conversationTopic.name ? '' : 'is-italic'">{{ conversationTopic.name || 'No Conversation Topic selected'}}</span>
                            <div v-if="conversationTopic.isAvailable != undefined">
                                <b-icon v-if="conversationTopic.isAvailable" type="is-success" title="Available" pack="fas" size="is-small" icon="check"></b-icon>
                                <b-icon v-if="!conversationTopic.isAvailable" type="is-danger" title="Unavailable" pack="fas" size="is-small" icon="times"></b-icon>
                            </div>
                        </div>
                    </b-field>
                    <b-field horizontal class="is-baseline-aligned">
                        <template slot="label">
                            Conversation Theme <span class="is-italic" style="font-variant:all-petite-caps">Optional</span>
                        </template>
                        <span class="control" :class="conversationTheme && conversationTheme.name ? '' : 'is-italic'">{{ conversationTheme.name || 'No Conversation Theme selected'}}</span>
                    </b-field>
                    <b-field v-if="projectDescription" label="Description" horizontal class="is-baseline-aligned">
                        <span class="control">{{projectDescription}}</span>
                    </b-field>
                    <b-field label="Metric Weights" horizontal>
                        <div class="modal-button-control">
                            <span class="control is-italic">{{hasDefaultWeights ? 'Default Weights' : 'Custom Weights'}}</span>
                            <button type="button" class="button" @click="openWeightAdjustmentModal()">View Metric Weights</button>
                        </div>
                    </b-field>
                    <b-field label="Sharing status" horizontal v-if="isPublished" class="is-center-aligned">
                        <p>
                            This project has been shared with you by {{project.createdBy}}
                        </p>
                    </b-field>
            </section>
        </div>
        <div class=" box">
            <div class="level is-vcentered">
                <div class="level-left">
                    <h2 class="title is-size-4">Project Brand Columns</h2>
                </div>
            </div>
            <b-table
                :data="projectColumns"
                :columns="projectColumnHeaders"
                :default-sort-direction="'asc'"
                :striped="true"
                default-sort="id"
                detailed
                :show-detail-icon="true"
            >
                <template slot-scope="props">
                    <b-table-column field="name" label="Name" sortable>
                        <span>{{ props.row.name }}</span>
                    </b-table-column>
                    <b-table-column field="colour" label="" width ="10">
                        <verte v-model="props.row.colour" menuPosition="center" :enableAlpha="false" model="hex" disabled></verte>
                    </b-table-column>
                    <b-table-column field="brandTopic" label="Netbase Brand Topic" centered sortable >
                        <span>{{ props.row.brandTopic.name }}</span>
                    </b-table-column>
                    <b-table-column field="brandTopic" label="Topic status" centered sortable >
                        <div v-if="props.row.brandTopic.isAvailable != undefined">
                            <b-icon v-if="props.row.brandTopic.isAvailable" type="is-success" pack="fas" size="is-small" icon="check"></b-icon>
                            <b-icon v-if="!props.row.brandTopic.isAvailable" type="is-danger" pack="fas" size="is-small" icon="times"></b-icon>
                        {{ props.row.brandTopic.isAvailable ? 'Available' : 'Unavailable' }}
                        </div>
                    </b-table-column>
                    <b-table-column field="brandTheme" label="NB Brand Theme" centered sortable >
                        <span>{{ props.row.brandTheme && props.row.brandTopic.name ? props.row.brandTopic.name : 'None' }}</span>
                    </b-table-column>
                    <b-table-column field="fbPageId" label="FB Page" sortable >
                        <span v-if="props.row.fbPageId">
                            <i v-if="isSocialtoolsPageNotActive(props.row.fbPageInfo)" class="fas fa-times is-small has-text-danger" :title="props.row.fbPageInfo.activeStatus"></i>
                            {{ isSocialtoolsPageHasName(props.row.fbPageInfo) ? props.row.fbPageInfo.name : props.row.fbPageId }}
                        </span>
                        <span v-else>N/A</span>
                    </b-table-column>
                     <b-table-column field="twPageId" label="TW Page" sortable >
                        <span v-if="props.row.twPageId">
                            <i v-if="isSocialtoolsPageNotActive(props.row.twPageInfo)" class="fas fa-times is-small has-text-danger" :title="props.row.twPageInfo.activeStatus"></i>
                            {{ isSocialtoolsPageHasName(props.row.twPageInfo) ? props.row.twPageInfo.name : props.row.twPageId }}
                        </span>
                        <span v-else>N/A</span>
                    </b-table-column>
                    <b-table-column field="ytPageId" label="YT Page" sortable >
                        <span v-if="props.row.ytPageId">
                            <i v-if="isSocialtoolsPageNotActive(props.row.ytPageInfo)" class="fas fa-times is-small has-text-danger" :title="props.row.ytPageInfo.activeStatus"></i>
                            {{ isSocialtoolsPageHasName(props.row.ytPageInfo) ? props.row.ytPageInfo.name : props.row.ytPageId }}
                        </span>
                        <span v-else>N/A</span>
                    </b-table-column>
                    <b-table-column field="igPageId" label="IG Page" sortable >
                        <span v-if="props.row.igPageId">
                            <i v-if="isSocialtoolsPageNotActive(props.row.igPageInfo)" class="fas fa-times is-small has-text-danger" :title="props.row.igPageInfo.activeStatus"></i>
                            {{ isSocialtoolsPageHasName(props.row.igPageInfo) ? props.row.igPageInfo.name : props.row.igPageId }}
                        </span>
                        <span v-else>N/A</span>
                    </b-table-column>
                </template>
                <template slot="detail" slot-scope="props">
                    <div>
                        <label class="has-text-weight-semibold">Keywords: </label>
                        {{ props.row.keywords.join(', ') }}
                    </div>
                    <div>
                        <label class="has-text-weight-semibold">Excluded Keywords: </label>
                        {{ props.row.excludedKeywords.join(', ') }}
                    </div>
                    <socialtools-pages-info :projectColumn="props.row" />
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import projectService from '@/services/project-service.js';
import defaultMetricWeightService from '@/services/default-metric-weight-service';
import colourService from '@/services/colour-service.js';
import { projectServiceHelper } from '@/services/project-service-helper.js';
import ProjectWeightAdjustment from '@/components/ProjectWeightAdjustment.vue';
import constants from '@/constants.js';
import utilities from '@/services/utility-service.js';
import SocialtoolsPagesInfo from '@/components/SocialtoolsPagesInfo.vue';

export default {
    name: 'ViewProject',
    components: {
        SocialtoolsPagesInfo
    },
    props: {
        projectId: {
            type: Number,
            required: false
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        });
    },
    data () {
        return {
            fromRoute: null,
            projectServiceHelper,
            utilities,
            errorMessage: '',
            isPublish: false,
            isLoading: true,
            conversationTopic: {},
            conversationTheme: {},
            projectColumns: [],
            projectDescription: '',
            project: {
                name: '',
                state: constants.PROJECT_STATE.DRAFT
            },
            // Used to show the project column table headers even when table is empty: https://github.com/buefy/buefy/issues/568
            placeholderColumnHeaders: [
                { label: 'Name' },
                { label: 'Netbase Brand Topic' },
                { label: 'FB Page' },
                { label: 'TW Page' },
                { label: 'YT Page' },
                { label: 'IG Page' }
            ],

            projectMetricWeights: [],
            projectPillarWeights: [],
            defaultMetricWeights: [],
            defaultPillarWeights: []
        };
    },
    async created () {
        try {
            if (this.projectId) {
                let response = await projectService.getProject(this.projectId);
                let projectToView = response.data;
                this.project = projectToView;

                let projectJSON = JSON.parse(projectToView.projectJSON);
                this.projectDescription = projectJSON.description;
                setColoursToColumns(projectJSON.columns); // want to do this before setting the columns on the observed object

                this.projectColumns = projectJSON.columns || [];
                this.conversationTopic = projectJSON.conversationTopic ? { topicId: projectJSON.conversationTopic.id, name: projectJSON.conversationTopic.name, isAvailable: projectJSON.conversationTopic.isAvailable } : {};
                this.conversationTheme = projectJSON.conversationTheme ? { themeId: projectJSON.conversationTheme.id, name: projectJSON.conversationTheme.name } : {};
                this.projectMetricWeights = projectJSON.metricWeights || [];
                this.projectPillarWeights = projectJSON.pillarWeights || [];
            } else {
                this.isLoading = false;
            }

            this.defaultMetricWeights = (await defaultMetricWeightService.getDefaultMetricWeights()).data;
            this.defaultPillarWeights = (await defaultMetricWeightService.getDefaultPillarWeights()).data;
        } catch (error) {
            this.errorMessage = error.message;
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        openWeightAdjustmentModal () {
            let modalConfig = {
                parent: this,
                component: ProjectWeightAdjustment,
                hasModalCard: true,
                props: {
                    inputMetricWeights: this.projectMetricWeights,
                    inputPillarWeights: this.projectPillarWeights,
                    isReadOnly: true
                }
            };
            this.$buefy.modal.open(modalConfig);
        },
        isSocialtoolsPageNotActive (pageInfo) {
            return pageInfo && !pageInfo.isActive;
        },
        isSocialtoolsPageHasName (pageInfo) {
            return pageInfo && pageInfo.name;
        },
        handleBack (fallbackRoute) {
            if (!this.fromRoute.name) {
                this.$router.push(fallbackRoute);
            } else {
                this.$router.back();
            }
        }
    },
    computed: {
        isPublished () {
            return this.project.state === constants.PROJECT_STATE.PUBLISHED;
        },
        hasDefaultWeights () {
            let hasDefaultMetricWeights = this.projectMetricWeights.length === 0 ||
                JSON.stringify(this.projectMetricWeights) === JSON.stringify(this.defaultMetricWeights);
            let hasDefaultPillarWeights = this.projectPillarWeights.length === 0 ||
                JSON.stringify(this.projectPillarWeights) === JSON.stringify(this.defaultPillarWeights);
            return hasDefaultMetricWeights && hasDefaultPillarWeights;
        },
        projectColumnHeaders () {
            // check whether there are project brand columns present and if not use the placeholder columns
            return this.projectColumns.length > 0 ? [] : this.placeholderColumnHeaders;
        }
    }
};

let setColoursToColumns = (columns) => {
    // if a column doesn't have a colour specified then set it here
    let defaultColours = colourService.getColours;
    columns.forEach((col, index) => { if (!col.colour) col.colour = defaultColours[index]; });
};
</script>

<style lang="scss" scoped>
section.section.project-details {
    padding-top: 0rem;
    padding-bottom: 2rem;
}

.project-details {
    .field {
        margin-top:1.5rem;
    }

    .modal-button-control{
        display: flex;
        justify-content:flex-start;
        align-items: center;

        span{
            margin: 3px;
        }

        button{
            margin:0 1rem;
        }
    }
}

.is-baseline-aligned{
    align-items: baseline;
}
.is-center-aligned{
    align-items: center;
}
</style>
